import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './App';
import {BrowserRouter} from "react-router-dom";

declare var backend_url: string;

export const appPath = backend_url + "ozon";
document.addEventListener("DOMContentLoaded", function () {
    ReactDOM.render(
        <React.StrictMode>
            <BrowserRouter
                basename={appPath}
            >
                <App/>
            </BrowserRouter>
        </React.StrictMode>,
        document.getElementById('root')
    );
})


